import {
  Camera,
  DepthTexture,
  FloatType,
  RGBAFormat,
  Scene,
  SRGBColorSpace,
  WebGLRenderer,
  WebGLRenderTarget,
} from '@seddi/three';
import { EffectComposer } from '@seddi/three/examples/jsm/postprocessing/EffectComposer.js';
import { RenderPass } from '@seddi/three/examples/jsm/postprocessing/RenderPass.js';
import { ShaderPass } from '@seddi/three/examples/jsm/postprocessing/ShaderPass.js';
import { GammaCorrectionShader } from '@seddi/three/examples/jsm/shaders/GammaCorrectionShader.js';

export class DefaultRenderingPipeline {
  readonly renderer: WebGLRenderer;

  composer: EffectComposer;
  mainPass: RenderPass;
  gammaCorrectionPass: ShaderPass;

  constructor(renderer: WebGLRenderer) {
    this.renderer = renderer;

    // Force 32 bit precission for the depth buffer attachment
    const depthTexture = new DepthTexture(0, 0, FloatType);
    const renderTarget = new WebGLRenderTarget(0, 0, {
      colorSpace: SRGBColorSpace,
      depthTexture,
      format: RGBAFormat,
      samples: 4,
    });

    const composer = new EffectComposer(renderer, renderTarget);

    this.mainPass = new RenderPass();
    this.gammaCorrectionPass = new ShaderPass(GammaCorrectionShader);
    composer.addPass(this.mainPass);
    composer.addPass(this.gammaCorrectionPass);
    this.composer = composer;
  }

  dispose() {
    this.composer.dispose();
    this.mainPass.dispose();
    this.gammaCorrectionPass.dispose();
  }

  setCamera(camera: Camera) {
    this.mainPass.camera = camera;
  }

  setScene(scene: Scene) {
    this.mainPass.scene = scene;
  }

  setSize(width: number, height: number) {
    this.composer.setSize(width, height);
  }

  render(deltaTime?: number) {
    // assert(camera !== null)
    // assert(scene !== null)
    this.composer.render(deltaTime);
  }
}
